import { ICustomLookupColumn, ICustomLookupOptions } from '../constants';
import { DEFAULT_SEARCH_SCREEN_DIALOG_STYLE } from './customLookupDefaults.contants';
export const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
    {
        dataField: 'CustomerProductCode',
        caption: 'Customer product',
        allowResizing: true,
        minWidth: 150,
        width: 150,
        fixed: false
    },
    {
        dataField: 'ProductCode',
        caption: 'Our product',
        allowResizing: true,
        minWidth: 150,
        width: 150,
        fixed: false
    },
    {
        dataField: 'Description',
        caption: 'Description',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: false
    }
];

export const customerProductLookupConstants: ICustomLookupOptions = {
    columns: LOOKUP_COLUMNS,
    dialogStyle: DEFAULT_SEARCH_SCREEN_DIALOG_STYLE,
    hideColumnHeaders: false,
    disableGridColumnLines: false,
    dataPrefix: 'Details',
    tabbedLookup: {
        isTabbedLookup: true,
    }
};
